import { CompactListColumn } from '../models';
import { marker as _translate } from '@biesbjerg/ngx-translate-extract-marker';

export class ColumnFactory {
    static getInventoryColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'inventoryNumberWithoutPrefix',
                name: _translate('Inventory number'),
                icon: '<i class="fa-solid fa-bus-simple"></i>',
                visible: true,
                width: 40
            }, ...config
        });
    }

    static getInventoryWithPrefixColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'inventoryNumber',
                name: _translate('Inventory number'),
                icon: '<i class="fa-solid fa-bus-simple"></i>',
                visible: true,
                width: 40
            }, ...config
        });
    }


    static getDeviationColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'deviation',
                name: _translate('Deviation'),
                icon: '<i class="fas fa-clock"></i>',
                visible: true,
                sortByKey: 'deviationseconds',
                width: 50
            }, ...config
        });
    }

    static getTimeColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'time',
                name: _translate('Deviation'),
                icon: '<i class="fas fa-clock"></i>',
                visible: true,
                sortByKey: 'timeSeconds',
                width: 50
            }, ...config
        });
    }

    static getMeasuredAtColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'measuredAt',
                name: _translate('Measured at'),
                icon: '<i class="fas fa-clock"></i>',
                visible: true,
                sortByKey: 'measuredAtDate',
                width: 50
            }, ...config
        });
    }

    static getNextStopColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'stop',
                name: _translate('Stop'),
                icon: '<i class="fas fa-arrow-right"></i>',
                visible: true,
                width: 90
            }, ...config
        });
    }

    static getActivityDescription(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'description',
                name: _translate('From - to'),
                icon: '<i class="fas fa-arrow-right"></i>',
                visible: true,
                width: 90
            }, ...config
        });
    }

    static getActivityTime(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'time',
                name: _translate('Time'),
                icon: '<i class="fas fa-clock"></i>',
                visible: true,
                width: 60
            }, ...config
        });
    }

    static getActivityType(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'activityType',
                name: _translate('Activity'),
                icon: '<i class="fas fa-bars"></i>',
                template: 'tags',
                visible: true,
                width: 48,
                tagColorKey: 'activityTypeColor'
            }, ...config
        });
    }

    static getRouteNumberColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'routeNumber',
                name: _translate('Route'),
                icon: '<i class="fas fa-route"></i>',
                visible: true,
                width: 32,
                sortNumeric: true
            }, ...config
        });
    }

    static getTripNumberColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'tripNumber',
                name: _translate('Trip number'),
                icon: '<i class="fas fa-code-branch"></i>',
                visible: true,
                width: 32,
                sortNumeric: true
            }, ...config
        });
    }

    static getTripDescriptionColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'tripDescription',
                name: _translate('Trip description'),
                icon: '<i class="fas fa-code-branch"></i>',
                visible: true,
                width: 120,
            }, ...config
        });
    }

    static getBlockNumberColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'blockNumber',
                name: _translate('Block number'),
                icon: '<i class="fas fa-circle-notch"></i>',
                visible: true,
                width: 38,
                sortNumeric: true
            }, ...config
        });
    }

    static getSpeedColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'speed',
                name: _translate('Speed'),
                icon: '<i class="fas fa-tachometer-alt"></i>',
                template: 'dots',
                visible: true,
                width: 30
            }, ...config
        });
    }

    static getBearingColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'bearing',
                name: _translate('Bearing'),
                icon: '<i class="fas fa-compass"></i>',
                template: 'bearing',
                visible: true,
                width: 25
            }, ...config
        });
    }

    static getColorColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'color',
                name: _translate('Color'),
                icon: '',
                template: 'color',
                visible: true,
                width: 20
            }, ...config
        });
    }

    static getWarningColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'warnings',
                name: _translate('Warnings'),
                icon: '<i class="fas fa-exclamation-triangle"></i>',
                visible: true,
                width: 20
            }, ...config
        });
    }

    static getWarningTextColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'warningText',
                name: _translate('Warning'),
                icon: '<i class="fas fa-comment-dots"></i>',
                visible: true,
                width: 200
            }, ...config
        });
    }

    static getWarningIconColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'warningIcon',
                name: _translate('Warning'),
                icon: '<i class="fas fa-exclamation-triangle"></i>',
                visible: true,
                width: 20,
                template: 'warningIcon'
            }, ...config
        });
    }

    static getWarningListColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'warningList',
                name: _translate('Warning'),
                icon: '<i class="fas fa-exclamation-triangle"></i>',
                visible: true,
                width: 40,
                template: 'warningList'
            }, ...config
        });
    }

    static getVehicleListColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'vehicleList',
                name: _translate('Vehicles'),
                icon: '<i class="fa-solid fa-bus-simple"></i>',
                visible: true,
                width: 200,
                template: 'vehicleList'
            }, ...config
        });
    }

    static getGarageColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'garageCode',
                name: _translate('Garage'),
                icon: '<i class="fas fa-warehouse"></i>',
                visible: true,
                width: 40
            }, ...config
        });
    }

    static getTrafficAreaNameColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'trafficAreaName',
                name: _translate('Garage'),
                icon: '<i class="fas fa-warehouse"></i>',
                visible: true,
                width: 50
            }, ...config
        });
    }

    static getStateOfChargeColumm(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'stateOfCharge',
                name: _translate('State of charge'),
                icon: '<i class="fas fa-battery-full"></i>',
                visible: true,
                width: 40,
                sortNumeric: true
            }, ...config
        });
    }

    static getArrivalTimeColumn(config?: any): CompactListColumn {
        return new CompactListColumn({
            ...{
                key: 'arrivalTime',
                name: _translate('Arrival time'),
                icon: '<i class="fas fa-clock"></i>',
                visible: true,
                width: 32,
                sortNumeric: true
            }, ...config
        });
    }
}
